export enum ApiWorkflowDialogSteps {
  UserEntry,
  UserConfirmation,
  UserSubmitted,
}
